import { mixed, number, object, string } from "yup";
import i18n from "../../../locales/i18n";
import { isExists } from "../../../utils";
import { email_regex } from "../../../utils/regex";
import { ExchangeRateUnitEnum } from "../../../utils/enum";

export const invoiceGroupValidationSchema = object({
  name: string().required(
    i18n.t("resources.sales.order.invoiceGroup.valid.enter_invoice_name")
  ),
  email: string()
    .nullable()
    .email(i18n.t("resources.sales.order.invoiceGroup.valid.invalid_email"))
    .test(
      i18n.t("resources.sales.order.invoiceGroup.valid.invalid_email"),
      i18n.t("resources.sales.order.invoiceGroup.valid.invalid_email"),
      function () {
        if (isExists(this.parent.email) && email_regex.test(this.parent.email))
          return false;

        return true;
      }
    ),
  invoiceDay: number()
    .required(
      i18n.t("resources.sales.order.invoiceGroup.valid.enter_invoice_day")
    )
    .min(1, i18n.t("resources.sales.order.invoiceGroup.valid.min_1"))
    .max(
      31,
      i18n.t("resources.sales.order.invoiceGroup.valid.invoice_day_max_31")
    ),
  invoiceBillingAddressId: string().required(
    i18n.t("resources.sales.order.invoiceGroup.valid.select_billing_address")
  ),
  invoiceDeliveryAddressId: string().required(
    i18n.t("resources.sales.order.invoiceGroup.valid.select_delivery_address")
  ),
  exchangeRateUnitId: mixed().required(
    i18n.t("resources.sales.order.invoiceGroup.valid.select_exchange_rate_unit")
  ),
  termsOfPaymentId: mixed().required(
    i18n.t("resources.sales.order.invoiceGroup.valid.select_terms_of_payment")
  ),
  currencyId: string().required(
    i18n.t("resources.sales.order.invoiceGroup.valid.select_currency")
  ),
  exchangeBuyingRate: number()
    .nullable()
    .when("exchangeRateUnitId", {
      is: (exchangeRateUnitId: number) =>
        exchangeRateUnitId === ExchangeRateUnitEnum.FixedRate,
      then: number()
        .typeError(
          i18n.t(
            "resources.sales.order.invoiceGroup.valid.required_buying_rate"
          )
        )
        .required(
          i18n.t(
            "resources.sales.order.invoiceGroup.valid.required_buying_rate"
          )
        ),
    }),
  exchangeSellingRate: number()
    .nullable()
    .when("exchangeRateUnitId", {
      is: (exchangeRateUnitId: number) =>
        exchangeRateUnitId === ExchangeRateUnitEnum.FixedRate,
      then: number()
        .typeError(
          i18n.t(
            "resources.sales.order.invoiceGroup.valid.required_selling_rate"
          )
        )
        .required(
          i18n.t(
            "resources.sales.order.invoiceGroup.valid.required_selling_rate"
          )
        ),
    }),
  invoiceDescription: string()
    .nullable()
    .max(
      50,
      ({ max }) =>
        `${max} ${i18n.t(
          "resources.sales.order.invoiceGroup.valid.max_length"
        )}`
    ),
  invoiceDescription2: string()
    .nullable()
    .max(
      50,
      ({ max }) =>
        `${max} ${i18n.t(
          "resources.sales.order.invoiceGroup.valid.max_length"
        )}`
    ),
  invoiceDescription3: string()
    .nullable()
    .max(
      50,
      ({ max }) =>
        `${max} ${i18n.t(
          "resources.sales.order.invoiceGroup.valid.max_length"
        )}`
    ),
});
